import {
	GET_ACS_SCHEDULER,
	GET_ACS_SCHEDULER_SUCCESS,
	GET_ACS_SCHEDULER_FAIL,
	EDIT_ACS_SCHEDULE,
	RESET_ACS_SCHEDULE,
	ADD_ACS_SCHEDULE_REQUEST,
	ADD_ACS_SCHEDULE_SUCCESS,
	ADD_ACS_SCHEDULE_FAIL,
	RESET_ACS_SCHEDULE_ADD,
	EDIT_ACS_SCHEDULE_SUCCESS,
	EDIT_ACS_SCHEDULE_FAIL,
	ADD_ACS_SCHEDULE,
} from '../../constants/globalProfileConstants/acsSchedulerConstants';

/**
 * Reducer function for managing acs scheduler list state.
 *
 * This reducer handles actions related to fetching acs scheduler data.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the acs schedulerl list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const acsSchedulerListReducer = (
	state = { acsSchedulerList: {}, addACSSchedule: false },
	action
) => {
	switch (action.type) {
		case GET_ACS_SCHEDULER:
			return {
				loading: true,
			};
		case GET_ACS_SCHEDULER_SUCCESS:
			return {
				loading: false,
				acsSchedulerList: action.payload,
			};
		case GET_ACS_SCHEDULER_FAIL:
			return {
				loading: false,
				error: action.payload,
			};
		case ADD_ACS_SCHEDULE:
			return {
				...state,
				addACSSchedule: action.payload,
			};
		default:
			return state;
	}
};

export const acsScheduleEditReducer = (
	state = { editACSScheduleError: null, successMessage: '' },
	action
) => {
	switch (action.type) {
		case EDIT_ACS_SCHEDULE:
			return {
				...state,
				loadingEdit: true,
			};
		case EDIT_ACS_SCHEDULE_SUCCESS:
			return {
				...state,
				loadingEdit: false,
				successMessage: action.successMessage,
			};
		case EDIT_ACS_SCHEDULE_FAIL:
			return {
				...state,
				loadingEdit: false,
				editACSScheduleError: action.payload,
			};
		case RESET_ACS_SCHEDULE:
			return {
				...state,
				loadingEdit: false,
				successMessage: null,
				editACSScheduleError: null,
			};

		default:
			return state;
	}
};

export const acsScheduleAddReducer = (
	state = {
		addACSScheduleError: null,
		addACSScheduleSuccess: null,
		addData: null,
		loadingAdd: false,
	},
	action
) => {
	switch (action.type) {
		case ADD_ACS_SCHEDULE_REQUEST:
			return {
				...state,
				loadingAdd: true,
			};
		case ADD_ACS_SCHEDULE_SUCCESS:
			return {
				...state,
				loadingAdd: false,
				addACSScheduleSuccess: action.payload,
			};
		case ADD_ACS_SCHEDULE_FAIL:
			return {
				...state,
				loadingAdd: false,
				addACSScheduleError: action.payload,
			};
		case RESET_ACS_SCHEDULE_ADD:
			return {
				...state,
				loadingAdd: false,
				addACSScheduleError: null,
				addACSScheduleSuccess: null,
				addData: null,
			};

		default:
			return state;
	}
};
